/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import type Mithril from 'mithril';
import type Article from 'flarum/orell-articles/models/Article';
import ArticleStatus from './ArticleStatus';

export interface BookListItemAttrs extends ComponentAttrs {
	article?: Article;
}

export default class BookListItem<CustomAttrs extends BookListItemAttrs = BookListItemAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { article } = this.attrs;

		if (!article) {
			return null;
		}

		return (
			<div className="BookListItem">
				<Link href={app.route.of_article(article)}>
					<img className="BookListItem-image" src={article.coverImage()} />

					<ArticleStatus article={article} />
				</Link>
			</div>
		);
	}
}
